import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../../mixins/inject-styles';

import styles from './jtn-ui-record-statistics.styles.scss?module';

interface Events {
  onCommentsClicked: Event;
  onDiscussClicked: Event;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiRecordStatistics',
    props: {
      commentsUrl: {
        required: true,
        type: String,
        default: ''
      },
      discussUrl: {
        required: true,
        type: String,
        default: ''
      },
      commentsCount: {
        type: Number,
        default: 0
      },
      isCommentsAllowed: {
        type: Boolean,
        default: false
      },
      viewsCount: {
        type: Number,
        default: 0
      },
      target: {
        type: String
      },
      color: {
        type: String
      }
    },
    methods: {
      formatNumber(number: number | string) {
        return number.toLocaleString('ru-RU');
      }
    },
    render() {
      return (
        <div class={[styles.statisticBlock, styles[this.color]]}>
          <span class={styles.statistic} data-test="record-stats-view">
            <svg class={styles.statisticIcon} width={16} height={16} stroke-width={1.5}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-eye-small"></use>
            </svg>
            <span class={styles.statisticValue}>
              {this.formatNumber(this.viewsCount)}
            </span>
          </span>
          {this.isCommentsAllowed &&
            (this.commentsCount > 0
              ? this.commentsUrl && (
                  <a
                    href={this.commentsUrl}
                    class={styles.statistic}
                    v-on:click={(event: Event) => this.$emit('commentsClicked', event)}
                    data-test="record-stats-comments-count"
                    target={this.target}
                  >
                    <svg
                      class={styles.statisticIcon}
                      width={16}
                      height={16}
                      stroke-width={1.5}
                    >
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-replies-to-comments"></use>
                    </svg>

                    <span class={styles.statisticValue}>
                      {this.formatNumber(this.commentsCount)}
                    </span>
                  </a>
                )
              : this.discussUrl && (
                  <a
                    href={this.discussUrl}
                    class={[styles.statistic, styles.discuss]}
                    v-on:click={(event: Event) => this.$emit('discussClicked', event)}
                    data-test="record-stats-comments-discuss"
                    target={this.target}
                  >
                    <svg
                      class={styles.statisticIcon}
                      width={16}
                      height={16}
                      stroke-width={1.5}
                    >
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-reply-to-comment"></use>
                    </svg>
                    <span class={[styles.statisticValue, styles.text]}>Обсудить</span>
                  </a>
                ))}
        </div>
      );
    }
  });
